import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchResultComponent } from './search-result/search-result.component';
import { ProductDetailComponent } from '../product/productdetail/product.detail.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BuyPageComponent } from './buy.page.component';
import { AdsModule } from '../adcomponents/ad.module';
import { NgProgressModule } from 'ngx-progressbar';
import { ProductDetailModule } from '../product/product.detail.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgDragDropModule } from 'ng-drag-drop';
import { EventListenerService } from '../services/close-listenenr.service';
import { SharedModule } from '../shared/shared.module';
import { MatSelectModule } from '@angular/material/select';
import { FilterPipe } from './../shared/filter.pipe';
import { BuyPageRoutingModule } from './buy.page.routing.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgSelectModule } from '@ng-select/ng-select';
import { BreadcrumbService } from '../services/breadcrumb.service';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { ChildHeaderModule } from '../child-header/child-header.module';
import { MatSortModule } from '@angular/material/sort';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import { BreadcrumbModule } from '../breadcrumb/breadcumb.module';
import { MatSlideToggle, MatSlideToggleModule } from '@angular/material/slide-toggle';

@NgModule({
    imports: [
        CommonModule,
        BuyPageRoutingModule,
        AdsModule,
        NgProgressModule,
        NgbModule,
        ProductDetailModule,
        NgxPaginationModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        MatSelectModule,
        MatSortModule,
        MatFormFieldModule,
        MatInputModule,
        NgDragDropModule.forRoot(),
        MatTableModule,
        MatCheckboxModule,
        MatButtonToggleModule,
        MatTooltipModule,
        NgSelectModule,
        MatProgressSpinnerModule,
        ChildHeaderModule,
        BreadcrumbModule,
        MatSlideToggleModule
    ],
    declarations: [
        BuyPageComponent,
        SearchResultComponent,
        FilterPipe,
    ],
    exports: [ProductDetailComponent],
    providers: [EventListenerService, BreadcrumbService],
    entryComponents: [ProductDetailComponent]
})
export class BuyPageModule { }

// tslint:disable-next-line:max-line-length
// todo: You can also create a new NgModule that exports and includes
//  MidAdComponent then import that NgModule in BuyPageModule and AppModule.
